import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import { get } from 'vuex-pathify';
import { notify } from "../../functions/notifications";
export default {
  name: 'ManageTeam',
  components: {
    ManageTeamMemberForm: require("./ManageTeamMemberForm").default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    wrapped: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      activeLoading: null,
      brokenUrls: [],
      editTeamMemberId: null,
      hovered: null,
      manageTeamMemberFormActive: false,
      searchInput: null,
      showWarning: false,
      uploadReason: null
    };
  },
  computed: {
    hasActiveSettingsTeamMember: get('manageTeam/hasActiveSettingsTeamMember'),
    filteredMembers: function filteredMembers() {
      var _this = this;

      if (!this.teamMembers || !this.teamMembers.length) {
        return [];
      }

      return this.teamMembers.filter(function (member) {
        return (member.displayName || '').toLowerCase().indexOf((_this.searchInput || '').toLowerCase()) !== -1;
      });
    },
    sortedMembers: function sortedMembers() {
      // Sort by Status, Weight then Display Name
      if (!this.teamMembers || !this.teamMembers.length) {
        return [];
      } // Assigning to a const so that we are not editing other values inside a computed property


      var filteredMembers = this.filteredMembers;
      return filteredMembers.sort(function (a, b) {
        // Sort by Status descending (active first)
        if (a.status > b.status) {
          return -1;
        }

        if (a.status < b.status) {
          return 1;
        } // Sort by Weight descending


        if (a.weight > b.weight) {
          return -1;
        }

        if (a.weight < b.weight) {
          return 1;
        } // Sort alphabetically by Display Name


        return ('' + a.displayName).toLowerCase() > ('' + b.displayName).toLowerCase() ? 1 : -1;
      });
    },
    getActiveTeamMember: function getActiveTeamMember() {
      var _this2 = this;

      if (this.editTeamMemberId && this.teamMembers) {
        return this.teamMembers.find(function (obj) {
          return obj.id === _this2.editTeamMemberId;
        });
      }

      return null;
    },
    // pathify getters
    loggedInMember: get('settings/loggedInMember'),
    teamMembers: get('manageTeam/teamData@teamMembers')
  },
  watch: {
    value: function value(activated) {
      /**
       * Moved fetchTeamDate() out of mounted() hook to here so that we only fetch data when
       * the component is activated.
       *
       * This prevents data from being fetched when the component is included on a page
       * even though the popup hasn't been triggered yet.
       */
      if (activated && !this.wrapped) {
        this.fetchTeamMembers();
      }
    }
  },
  mounted: function mounted() {
    if (this.wrapped) {
      this.fetchTeamMembers();
    }
  },
  methods: {
    addOrUpdateTeamMember: function addOrUpdateTeamMember(payload) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var member, mode, object, uploadMember, action, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                member = payload.data;
                mode = payload.mode;

                if (!(!member || !mode)) {
                  _context.next = 6;
                  break;
                }

                object = (!member ? 'member' : '') + (!mode && !member ? ' and ' : '') + (!mode ? 'mode' : '');
                Logger.warn('addOrUpdateTeamMember requires a ' + object);
                return _context.abrupt("return");

              case 6:
                uploadMember = cloneDeep(member);
                _this3.uploadReason = mode;
                action = mode === 'add' ? 'addTeamMember' : 'updateTeamMember';
                _context.next = 11;
                return _this3.$store.dispatch('manageTeam/' + action, uploadMember);

              case 11:
                res = _context.sent;
                _this3.searchInput = '';

                if (res) {
                  _context.next = 16;
                  break;
                }

                _this3.$q.loading.hide();

                return _context.abrupt("return");

              case 16:
                notify(_this3.$tc('manageTeam.' + mode + 'Success', member.displayName), _this3.$t('manageTeam.justNow'), 'positive');

                _this3.$q.loading.hide();

                _this3.closeManageTeamMemberForm();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    closeIfOk: function closeIfOk() {
      // Ensure there's at least one enabled team member with a pin code and access to settings
      // before allowing the user to close Manage Team and display a suitable message if not
      if (this.hasActiveSettingsTeamMember) {
        this.$emit('close');
      } else {
        this.showWarning = true;
      }
    },
    closeManageTeamMemberForm: function closeManageTeamMemberForm() {
      this.editTeamMemberId = null;
      this.manageTeamMemberFormActive = false;
    },
    deleteTeamMember: function deleteTeamMember(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var member, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id && _this4.teamMembers) {
                  _context2.next = 3;
                  break;
                }

                Logger.warn('deleteTeamMember requires teamMembers');
                return _context2.abrupt("return");

              case 3:
                _this4.$q.loading.show({
                  message: _this4.$t('manageTeam.deletingTeamMember')
                });

                member = _this4.teamMembers.find(function (item) {
                  return item.id === id;
                });

                if (member) {
                  _context2.next = 9;
                  break;
                }

                Logger.warn('deleteTeamMember requires a member');

                _this4.$q.loading.hide();

                return _context2.abrupt("return");

              case 9:
                _context2.next = 11;
                return _this4.$store.dispatch('manageTeam/deleteTeamMember', member);

              case 11:
                res = _context2.sent;

                _this4.$q.loading.hide();

                _this4.searchInput = '';

                if (res) {
                  notify(_this4.$tc('manageTeam.deleteSuccess', member.displayName), _this4.$t('manageTeam.justNow'));

                  _this4.closeManageTeamMemberForm();
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fetchTeamMembers: function fetchTeamMembers() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //  JR TODO: Check if this is going to get downloaded with the
                //  config and will therefore already be in the state store
                _this5.$q.loading.show({
                  message: _this5.$t('manageTeam.loadingTeamData')
                });

                _context3.next = 3;
                return _this5.$store.dispatch('manageTeam/fetchTeamMembers');

              case 3:
                res = _context3.sent;

                if (res) {// success
                } else {
                  // fail
                  Logger.warn('fetchTeamMembers returned no response');
                }

                _this5.$q.loading.hide();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    addTeamMemberPhotoBroken: function addTeamMemberPhotoBroken(id) {
      this.brokenUrls.push(id);
    },
    photoBroken: function photoBroken(id) {
      return this.brokenUrls.includes(id);
    },
    isHovered: function isHovered(id) {
      return id === this.hovered;
    },
    setEditTeamMember: function setEditTeamMember(id) {
      this.editTeamMemberId = id;
      this.manageTeamMemberFormActive = true;
    },
    toggleStatus: function toggleStatus(member) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var id, status;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (member) {
                  _context4.next = 3;
                  break;
                }

                Logger.error('member not found');
                return _context4.abrupt("return");

              case 3:
                if (_this6.activeLoading) {
                  _context4.next = 13;
                  break;
                }

                // get member id and toggled member status (convert bool to tinyint)
                id = member.id;
                status = member.status ? 0 : 1;

                if (id) {
                  _context4.next = 9;
                  break;
                }

                Logger.error('member id not found');
                return _context4.abrupt("return");

              case 9:
                _this6.activeLoading = id;
                _context4.next = 12;
                return _this6.$store.dispatch('manageTeam/updateTeamMember', {
                  id: id,
                  status: status
                });

              case 12:
                _this6.activeLoading = null;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};